
import { defineComponent, ref } from 'vue'
import { object } from 'yup'
import { myValidationSchemaObj, validationMessage } from '@/views/validation'
import { useForm } from 'vee-validate'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { services } from '@/services/services'
import { callApiWrapper } from '@/views/callApiWrapper'
import { useStore } from 'vuex'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'

const service = services.updatePassword

interface InputForm {
  newPassword: string;
}

const validationSchema = object({
  newPassword: myValidationSchemaObj.password
})

export default defineComponent({
  components: {
    ResponseResultAlert,
    ContentLayout
  },
  setup () {
    const confirmPassword = ref<string>('')
    const requestError = ref<string | null>(null)
    const isSucceed = ref<boolean>(false)
    const store = useStore()
    const { errors, values, meta, validate, setFieldError } = useForm<InputForm>({
      validationSchema: validationSchema,
      validateOnMount: false
    })

    const updatePassword = async () => {
      if (values.newPassword !== confirmPassword.value) {
        setFieldError('newPassword', validationMessage.notMatchNewPassword)
        return
      }

      isSucceed.value = false
      requestError.value = null

      await callApiWrapper(requestError, async () => {
        await service.updateInitialPassword(values.newPassword)
        isSucceed.value = true
        await store.dispatch('userStatus/update')
      })
    }

    const dismissAlert = () => {
      isSucceed.value = false
      requestError.value = null
    }

    return {
      requestError,
      confirmPassword,
      isSucceed,
      values,
      errors,
      meta,
      validate,
      updatePassword,
      dismissAlert
    }
  }
})
